module.exports = __webpack_public_path__ + "media/order_new.57040f87.wav";